import React from 'react';
import { createPortal } from 'react-dom';
import { Pencil, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export const EditButton = ({ onClick, label = 'Rediger', testId }) => {
  const { user } = useAuth();
  if (!user?.is_admin) return null;
  return (
    <button type="button" onClick={onClick} data-testid={testId} className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-[#ffb400] text-black text-xs font-bold uppercase tracking-widest hover:bg-[#ffc733] transition-colors shadow-lg shadow-[#ffb400]/20">
      <Pencil size={13} /> {label}
    </button>
  );
};

export const EditorShell = ({ title, onClose, onSave, saving, children, testId = 'editor-dialog' }) => createPortal(
  <div className="fixed inset-0 z-[95] flex items-end md:items-center justify-center md:p-4" role="dialog" aria-modal="true" data-testid={testId}>
    <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
    <div className="relative w-full md:max-w-3xl max-h-[92vh] rounded-t-3xl md:rounded-3xl bg-[#0f0a17] border border-white/10 shadow-2xl flex flex-col">
      <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
        <h3 className="text-xl font-bold text-white" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{title}</h3>
        <button type="button" onClick={onClose} aria-label="Lukk" className="w-10 h-10 rounded-full border border-white/15 text-white flex items-center justify-center hover:border-[#ff2e2e] hover:text-[#ff2e2e]"><X size={18} /></button>
      </div>
      <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5">{children}</div>
      <div className="px-6 py-4 border-t border-white/10 flex justify-end gap-3">
        <button type="button" onClick={onClose} className="px-5 py-3 rounded-full border border-white/15 text-white font-semibold text-sm hover:border-white/40">Avbryt</button>
        <button type="button" onClick={onSave} disabled={saving} data-testid="editor-save-button" className="px-7 py-3 rounded-full bg-[#ff2e2e] text-black font-bold uppercase tracking-wide text-sm hover:bg-[#ff4d4d] disabled:opacity-50">{saving ? 'Lagrar…' : 'Lagre'}</button>
      </div>
    </div>
  </div>,
  document.body
);

export const inputCls = 'w-full px-4 py-3 rounded-2xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:border-[#ff2e2e] focus:outline-none transition-colors';
export const labelCls = 'block text-[11px] font-bold text-white/60 mb-1.5 uppercase tracking-wider';
